<template>
  <div class="portrayal">
    <div class="portrayal_f1 ">
        <p class="portrayal_title mb-30">
            <img src="../../assets/images/newIcon/vip_group_icon.png" alt="">
            <span>人群分析</span>
        </p>
        <div class="portrayal_content">
            <div class="portrayal_d1">
                <img src="../../assets/images/newIcon/vipgroup_defaultgroup_icon.png" alt="">
                <div>
                    <p>人群名称</p>
                    <p>人数：10000人 ｜ 当群组信息刷新后，图表数据同步更新</p>
                </div>
            </div>
            <div class="portrayal_d2">
                <div class="portrayal_group">
                    <p class="portrayal_t">
                        <img src="../../assets/images/newIcon/vipgroup_updaterecord_icon.png" alt="">
                        <span>群组规则</span>
                    </p>
                    <ul class="portrayal_lis">
                        <li class="portrayal_l" @click="dialogVisible3=true;">
                            <img src="../../assets/images/newIcon/useattribute_icon.png" alt="">
                            <span>用户属性满足</span>
                        </li>
                        <li class="portrayal_l">
                            <img src="../../assets/images/newIcon/usebehavior_icon.png" alt="">
                            <span>用户行为满足</span>
                        </li>
                        <li class="portrayal_l">
                            <img src="../../assets/images/newIcon/usebusiness_icon.png" alt="">
                            <span>用户业务规则满足</span>
                        </li>
                    </ul>
                </div>
                <div class="portrayal_label">
                    <p class="portrayal_t">
                        <img src="../../assets/images/newIcon/vip_viplabel_icon.png" alt="">
                        <span>会员标签</span>
                    </p>
                    <div class="portrayal_lab">
                        <el-tabs v-model="activeName" @tab-click="handleClick">
                            <el-tab-pane label="全部" name="1"></el-tab-pane>
                            <el-tab-pane label="运营标签" name="2"></el-tab-pane>
                            <el-tab-pane label="规则标签" name="3"></el-tab-pane>
                        </el-tabs>
                        <p>
                            <el-tag size="medium">中等标签</el-tag>
                            <el-tag size="medium">中等标签</el-tag>
                            <el-tag size="medium">中等标签</el-tag>
                            <el-tag size="medium">中等标签</el-tag>
                            <el-tag size="medium">中等标签</el-tag>
                            <el-tag size="medium">中等标签</el-tag>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
    <div class="tabs">
        <el-tabs v-model="activeName2" @tab-click="handleClick">
            <el-tab-pane label="基础数据" name="1"></el-tab-pane>
            <el-tab-pane label="业务数据" name="2"></el-tab-pane>
        </el-tabs>
    </div>
    <!-- 图表区域 -->
    <div v-show="activeName2==1" class="my-chart">
      <!-- 图1 -->
      <el-card shadow="never" class="my-chart-com">
        <div class="top clearfix">
          <div class="fl">
            <img src="../../assets/images/newIcon/pepole_targetcustomer_icon.png" alt="" />
            <span></span><b>目标客户群</b
            ><span class="text">目标客户群与总人数的占比</span>
          </div>
          <div class="fr">计算于：2021.07.07 00:18:12</div>
        </div>
        <div class="mian2 ybp">
          <div class="m1">
              <div data-v-801f2390="" role="progressbar" :aria-valuenow="percentage" aria-valuemin="0" aria-valuemax="100" class="el-progress el-progress--dashboard"><div class="el-progress-circle" style="height: 200px; width: 200px;"><svg viewBox="0 0 100 100">
                <defs>
                    <radialGradient id="grad1" cx="50%" cy="50%" r="50%" fx="60%" fy="20%">
                    <stop offset="0%" style="stop-color:rgb(0, 145, 255);stop-opacity:1" />
                    <stop offset="100%" style="stop-color:rgb(0, 195, 255);stop-opacity:1" />
                    </radialGradient>
                </defs>
                <path d="
                M 50 50
                m 0 47
                a 47 47 0 1 1 0 -94
                a 47 47 0 1 1 0 94
                " stroke="#e5e9f2" stroke-width="6.0" fill="none" class="el-progress-circle__track" style="stroke-dasharray: 221.482px, 295.31px; stroke-dashoffset: -36.9137px;"></path><path d="
                M 50 50
                m 0 47
                a 47 47 0 1 1 0 -94
                a 47 47 0 1 1 0 94
                " stroke="url(#grad1)" fill="none" stroke-linecap="round" stroke-width="6.0" class="el-progress-circle__path" style="stroke-dasharray: 18.0287px, 295.31px; stroke-dashoffset: -36.9137px; transition: stroke-dasharray 0.6s ease 0s, stroke 0.6s ease 0s;"></path></svg></div>
              </div>
              <!-- <el-progress :width="200" stroke-linecap="round" :stroke-width="12" type="dashboard" :percentage="percentage"> -->
                  
              <!-- </el-progress> -->
               <div class="fonts">
                    {{percentage}}<span>%</span> 
                </div>
          </div>
          <div class="m2">
            <h1>34,640<span>人</span></h1>
            <span>
              在全部客户中占比
              <span class="txtcolor">8.14%</span>
            </span>
          </div>
        </div>
      </el-card>
      <!-- 图2 -->
      <el-card shadow="never" class="my-chart-com">
        <div class="top clearfix">
          <div class="fl">
            <img src="../../assets/images/newIcon/gender_icon@2x.png" alt="" />
            <span></span><b>性别组织结构</b
            ><span class="text">目标客户群的性别组成占比</span>
          </div>
          <div class="fr">计算与:2021.07.07 00:18:12</div>
        </div>
        <div class="mian2">
          <div class="m1" id="c1"></div>
          <div class="m2">
            <h1>34,640<span>人</span></h1>
            <span
              >其中男性: <span class="txtcolor">100</span>人，女性:
              <span class="txtcolor">100</span>人，未知:
              <span class="txtcolor">100</span>人</span
            >
          </div>
        </div>
      </el-card>
      <!-- 图3 -->
      <el-card shadow="never" class="my-chart-com">
        <div class="top clearfix">
          <div class="fl">
            <img src="../../assets/images/newIcon/city_icon@2x.png" alt="" />
            <span></span><b>城市分布</b
            ><span class="text">目标客户群的所在城市分布</span>
          </div>
           <div id="myChartChina" :style="{width: '300px', height: '400px'}"></div>
        </div>
      </el-card>
      <!-- 图4 -->
      <el-card shadow="never" class="my-chart-com">
        <div class="top clearfix">
          <div class="fl">
            <img
              src="../../assets/images/newIcon/pepoleconsume_icon@2x.png"
              alt=""
            />
            <span></span><b>人群消费次数</b
            ><span class="text">过去90天的人群消费次数占比</span>
          </div>
        </div>
        <div class="main4">
          <div class="m1">
            0次：<span class="txtcolor">100</span>人，1次：<span
              class="txtcolor"
              >100</span
            >人，2次：<span class="txtcolor">100</span>人，3次：<span
              class="txtcolor"
              >100</span
            >人，4次：<span class="txtcolor">100</span>人
          </div>
          <div class="m2" id="c3"></div>
        </div>
      </el-card>
      <!-- 图5 -->
      <el-card shadow="never" class="my-chart-com">
        <div class="top clearfix">
          <div class="fl">
            <img
              src="../../assets/images/newIcon/pepoleaccess_icon@2x.png"
              alt=""
            />
            <span></span><b>人群访问次数</b
            ><span class="text">过去90天的人群访问分布占比</span>
          </div>
        </div>
        <div class="main4">
          <div class="m1">
            0次：<span class="txtcolor">100</span>人，2-5次：<span
              class="txtcolor"
              >100</span
            >人，5-10次：<span class="txtcolor">100</span>人，10-20次：<span
              class="txtcolor"
              >100</span
            >人，20次以上：<span class="txtcolor">100</span>人
          </div>
          <div class="m2" id="c4"></div>
        </div>
      </el-card>
      <!-- 图6 -->
      <el-card shadow="never" class="my-chart-com">
        <div class="top clearfix">
          <div class="fl">
            <img
              src="../../assets/images/newIcon/pepoleactive_icon@2x.png"
              alt=""
            />
            <span></span><b>人群月活跃度</b
            ><span class="text">过去一个月的人群月活跃度分布占比</span>
          </div>
        </div>
        <div class="mian2" style="position:relative;">
          <div class="m1" id="c5"></div>
          <div class="m2" style="position:absolute;right: 70px;">
            <p>
              <span style="display:inline-block; transform: translate(0px, -5px);">活跃人数：</span> <b style="font-size: 33px" class="txtcolor">34,640</b>
              <b style="font-size: 16px" class="txtcolor">人</b>
            </p>
            <p>
             <span style="display:inline-block; transform: translate(0px, -5px);">未活跃人数：</span> <b style="font-size: 33px" class="txtcolor">34,640</b>
              <b style="font-size: 16px" class="txtcolor">人</b>
            </p>
          </div>
        </div>
      </el-card>
      <!-- 图7 -->
      <el-card shadow="never" class="my-chart-com">
        <div class="top clearfix">
          <div class="fl">
            <img
              src="../../assets/images/newIcon/uselevel_icon@2x.png"
              alt=""
            />
            <span></span><b>会员等级占比</b
            ><span class="text">平台整体人群的会员等级分布</span>
          </div>
        </div>
        <div class="mian2 mian5">
          <div class="m1" id="c6"></div>
          <div class="m2">
            <p>
              青铜会员：<b  class="txtcolor">100</b>人
            </p>
            <p>
              黄金会员：<b  class="txtcolor">100</b>人
            </p>
            <p>
              白金会员：<b  class="txtcolor">100</b>人
            </p>
            <p>
              砖石会员：<b  class="txtcolor">100</b>人
            </p>
            <p>
              大师会员：<b  class="txtcolor">100</b>人
            </p>
          </div>
        </div>
      </el-card>
      <!-- 图8 -->
      <el-card shadow="never" class="my-chart-com">
        <div class="top clearfix">
          <div class="fl">
            <img
              src="../../assets/images/newIcon/sensitive_icon@2x.png"
              alt=""
            />
            <span></span><b>优惠券敏感度</b
            ><span class="text">平台整体人群在过去90天的优惠券消费排行</span>
          </div>
        </div>
        <div id="c7"></div>
      </el-card>
      <!-- 图9 -->
      <el-card shadow="never" class="my-chart-com my-table">
        <div class="tabl">
            <div class="top clearfix">
            <div class="fl" >
                <img
                src="../../assets/images/newIcon/customerlabel_icon@2x.png"
                alt=""
                />
                <span></span><b>顾客标签画像</b
                ><span class="text">展示应用次数最多的5个标签</span>
            </div>
            </div>
            <!-- 表格 -->
            <el-table :data="tableData" style="width: 100%" class="photo9"
             :header-cell-style="{background:'#EEEEEE',textAlign: 'center',fontSize:'12px'}"
              :cell-style="{textAlign: 'center',fontSize:'12px'}"
            >
            <el-table-column show-overflow-tooltip   prop="label" label="标签"> </el-table-column>
            <el-table-column prop="useUser" label="应用人数"> </el-table-column>
            <el-table-column prop="newUser" label="新用户"> </el-table-column>
            <el-table-column prop="oldUser" label="老用户"> </el-table-column>
            <el-table-column prop="payPercent" label="标签支付率">
            </el-table-column>
            </el-table>
        </div>
        <div class="box3">
          <div>
            <b style="font-size: 26px">3000</b>个
            <p>标签总数</p>
          </div>
          <div>
            <b style="font-size: 26px">300</b>个
            <p>运营总数</p>
          </div>
          <div>
            <b style="font-size: 26px">300</b>个
            <p>规则标签</p>
          </div>
        </div>
      </el-card>

      <!-- 图10 -->
      <el-card  shadow="never" class="my-chart-com my-table">
        <div class="top clearfix" style="background:#fff;">
          <div class="fl">
            <img src="../../assets/images/newIcon/channel_icon@2x.png" alt="" />
            <span></span><b>会员渠道占比</b
            ><span class="text">渠道系统默认渠道与手动添加渠道</span>
          </div>
        </div>
        <!-- 表格 -->
        <el-table
          :data="tableData1"
          style="width: 100%"
          class="photo9 customer-table"
          :header-cell-style="{background:'#EEEEEE',textAlign: 'center',fontSize:'12px'}"
              :cell-style="{textAlign: 'center',fontSize:'12px'}"
        >
          <el-table-column :show-overflow-tooltip="true" prop="label" label="渠道"> </el-table-column>
          <el-table-column prop="useUser" label="渠道人数"> </el-table-column>
          <el-table-column prop="newUser" label="一周使用时长"> </el-table-column>
          <el-table-column prop="oldUser" label="使用次数"> </el-table-column>
          <el-table-column prop="payPercent" label="次数留存率">
          </el-table-column>
        </el-table>
      </el-card>
    </div>
    <div v-show="activeName2==2">
      <seize></seize>
    </div>
    <el-dialog
        title="用户属性满足"
        :visible.sync="dialogVisible3"
        width="40%"
        :before-close="handleClose">
        <div class="dialogContent2">
            <ul class="lis">
                    <li class="li">
                        <div class="c">
                            <p class="icons">
                                <span>A</span>
                            </p>
                            <div>
                                <p class="title">VIP等级包含</p>
                                <p class="dj">
                                    <span>黄金会员</span>
                                    <span>黄金会员</span>
                                </p>
                            </div>
                        </div>
                        <div class="c">
                            <p class="icons">
                               <span>B</span>
                            </p>
                            <div>
                                <p class="title">性别 为</p>
                                <p class="xb">
                                    <span>男</span>
                                </p>
                            </div>
                        </div>
                        <div class="c">
                            <p class="icons">
                               <span>C</span>
                            </p>
                            <div>
                                <p class="title">来源渠道 包含</p>
                                <p class="qd">
                                    <span class="ft">小程序</span>
                                    <span class="f">
                                        <span>小程序模版消息</span>
                                        <span>小程序模版消息</span>
                                        <span>小程序模版消息</span>
                                        <span>小程序模版消息</span>
                                    </span>
                                    <span class="ft">自然注册</span>
                                    <span class="text">
                                        选择“自然注册”后，将筛选出通过自然搜索注册小程序与app的客户～
                                    </span>
                                    <span class="ft">自定义渠道</span>
                                    <span class="f">
                                        <span>公众号模版消息</span>
                                    </span>
                                </p>
                            </div>
                        </div>
                    </li>
            </ul>
        </div>
      
    </el-dialog>
  </div>
</template>

<script>
import { registerTheme, Chart } from "@antv/g2";
export default {
  data() {
    return {
        dialogVisible3:false,
        activeName:"1",
        activeName2:"1",
         percentage: 8.14,
        colors: [
          {color: '#f56c6c', percentage: 20},
          {color: '#e6a23c', percentage: 40},
          {color: '#5cb87a', percentage: 60},
          {color: '#1989fa', percentage: 80},
          {color: '#6f7ad3', percentage: 100}
        ],
      //模拟数据
      tableData: [
        {
          label: "购买",
          useUser: 3000,
          newUser: 200,
          oldUser: 2700,
          payPercent: "30.56%",
        },
        {
          label: "购买",
          useUser: 3000,
          newUser: 200,
          oldUser: 2700,
          payPercent: "30.56%",
        },
        {
          label: "购买",
          useUser: 3000,
          newUser: 200,
          oldUser: 2700,
          payPercent: "30.56%",
        },
        {
          label: "购买",
          useUser: 3000,
          newUser: 200,
          oldUser: 2700,
          payPercent: "30.56%",
        },
        {
          label: "购买",
          useUser: 3000,
          newUser: 200,
          oldUser: 2700,
          payPercent: "30.56%",
        },
      ],
      tableData1: [
        {
          label: "公众号",
          useUser: 3000,
          newUser: 200,
          oldUser: 2700,
          payPercent: "30.56%",
        },
        {
          label: "APP",
          useUser: 3000,
          newUser: 200,
          oldUser: 2700,
          payPercent: "30.56%",
        },
        {
          label: "小程序",
          useUser: 3000,
          newUser: 200,
          oldUser: 2700,
          payPercent: "30.56%",
        },
        {
          label: "今日头条",
          useUser: 3000,
          newUser: 200,
          oldUser: 2700,
          payPercent: "30.56%",
        },
        {
          label: "抖音",
          useUser: 3000,
          newUser: 200,
          oldUser: 2700,
          payPercent: "30.56%",
        },
        {
          label: "快手",
          useUser: 3000,
          newUser: 200,
          oldUser: 2700,
          payPercent: "30.56%",
        },
      ],
    };
  },
  mounted() {
    this.drawLine();
    //性别图
    this.init();
    //人群消费次数图
    this.init2();
    //人群访问分布图
    this.init3();
    //人群活跃度图
    this.init4();
    //会员等级占比图
    this.init5();
    //优惠券敏感都
    this.init6();
  },
  methods: {
    handleClick(){

    },
    handleClose(){
      this.dialogVisible3=false;
    },
     drawLine() {
            // 基于准备好的dom，初始化echarts实例
            var myChartContainer = document.getElementById('myChartChina')
            var resizeMyChartContainer = function() {
                myChartContainer.style.width = 600+'px' // 页面一半的大小
            }
            resizeMyChartContainer()
            var myChartChina = this.$echarts.init(myChartContainer)
            function randomData() {
            return Math.round(Math.random() * 500)
            }
            // 绘制图表
            var optionMap = {
            tooltip: {
                trigger: 'item',
                formatter: '{b}：{c}'
            },
            // legend: {
            //   orient: 'vertical',
            //   left: 'left',
            //   data: ['']
            // },

            visualMap: {
                min: 0,
                max: 1500,
                orient: 'horizontal',
                right: 'auto',
                top: 'bottom',
                text: ['高', '低'],
                calculable: true,
                color: ['#0b50b9', '#c3e2f4']
            },
            selectedMode: 'single',
            series: [{
                name: '',
                type: 'map',
                top: '2%',
                // left: '10%',
                // right: '10%',
                bottom: '2%',
                mapType: 'china',
                itemStyle: {
                normal: {
                    borderColor: '#fff',
                     areaColor:'#45a1ff'//默认区域颜色
                },
                emphasis: {
                    shadowOffsetX: 0,
                    shadowOffsetY: 0,
                    shadowBlur: 20,
                    borderWidth: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)',
                     areaColor: 'red',//鼠标滑过区域颜色
                },
                },
                
                showLegendSymbol: true,
                label: {
                normal: {
                    show: false //隐藏省份名字
                },
                emphasis: {
                    show: true
                }
                },
                data: [
                    { name: '北京', selected: false, value: 1 },
                    { name: '天津', selected: false, value: 2 },
                    { name: '上海', selected: false, value: 3 },
                    { name: '重庆', selected: false, value: 4 },
                    { name: '河北', selected: false, value: 5 },
                    { name: '河南', selected: false, value: 6 },
                    { name: '云南', selected: false, value: 7 },
                    { name: '辽宁', selected: false, value: 8 },
                    { name: '黑龙江',selected: false, value: 9 },
                    { name: '湖南', selected: false, value: 10 },
                    { name: '安徽', selected: false, value: 11 },
                    { name: '山东', selected: false, value: 12 },
                    { name: '新疆', selected: false, value: 13 },
                    { name: '江苏', selected: false, value: 14 },
                    { name: '浙江', selected: false, value: 15 },
                    { name: '江西', selected: false, value: 16 },
                    { name: '湖北', selected: false, value: 17 },
                    { name: '广西', selected: false, value: 18 },
                    { name: '甘肃', selected: false, value: 19 },
                    { name: '山西', selected: false, value: 20 },
                    { name: '内蒙古', selected: false, value: 21 },
                    { name: '陕西', selected: false, value: 22 },
                    { name: '吉林', selected: false, value: 23 },
                    { name: '福建', selected: false, value: 24 },
                    { name: '贵州', selected: false, value: 25 },
                    { name: '广东', selected: false, value: 26 },
                    { name: '青海', selected: false, value: 27 },
                    { name: '西藏', selected: false, value: 28 },
                    { name: '四川', selected: false, value: 29 },
                    { name: '宁夏', selected: false, value: 30 },
                    { name: '海南', selected: false, value: 31 },
                    { name: '台湾', selected: false, value: 32 },
                    { name: '香港', selected: false, value: 33 },
                    { name: '澳门', selected: false, value: 34 }
                ] //各省地图颜色数据依赖valu
            }],
                dataRange: {
                x: '-1000 px', //图例横轴位置
                y: '-1000 px', //图例纵轴位置
                splitList: [
                    { start: 1, end: 1, label: '北京', color: '#2f61aa' },
                    { start: 2, end: 2, label: '天津', color: '#2f61aa' },
                    { start: 3, end: 3, label: '上海', color: '#2e61a9' },
                    { start: 4, end: 4, label: '重庆', color: '#c5ebfe' },
                    { start: 5, end: 5, label: '河北', color: '#3b89e0' },
                    { start: 6, end: 6, label: '河南', color: '#3b89e0' },
                    { start: 7, end: 7, label: '云南', color: '#a2dbff' },
                    { start: 8, end: 8, label: '辽宁', color: '#45a1ff' },
                    { start: 9, end: 9, label: '黑龙江', color: '#45a1ff' },
                    { start: 10, end: 10, label: '湖南', color: '#45a1ff' },
                    { start: 11, end: 11, label: '安徽', color: '#3b89e0' },
                    { start: 12, end: 12, label: '山东', color: '#45a1ff' },
                    { start: 13, end: 13, label: '新疆', color: '#c5ebfe' },
                    { start: 14, end: 14, label: '江苏', color: '#2e61a9' },
                    { start: 15, end: 15, label: '浙江', color: '#2e61a9' },
                    { start: 16, end: 16, label: '江西', color: '#439efb' },
                    { start: 17, end: 17, label: '湖北', color: '#80caff' },
                    { start: 18, end: 18, label: '广西', color: '#64b4ff' },
                    { start: 19, end: 19, label: '甘肃', color: '#c5ebfe' },
                    { start: 20, end: 20, label: '山西', color: '#45a1ff' },
                    { start: 21, end: 21, label: '内蒙古',color: '#a2dbff' },
                    { start: 22, end: 22, label: '陕西', color: '#80caff' },
                    { start: 23, end: 23, label: '吉林', color: '#45a1ff' },
                    { start: 24, end: 24, label: '福建', color: '#439efb' },
                    { start: 25, end: 25, label: '贵州', color: '#80caff' },
                    { start: 26, end: 26, label: '广东', color: '#439efb' },
                    { start: 27, end: 27, label: '青海', color: '#c5ebfe' },
                    { start: 28, end: 28, label: '西藏', color: '#c5ebfe' },
                    { start: 29, end: 29, label: '四川', color: '#c5ebfe' },
                    { start: 30, end: 30, label: '宁夏', color: '#c5ebfe' },
                    { start: 31, end: 31, label: '海南', color: '#439efb' },
                    { start: 32, end: 32, label: '台湾', color: '#439efb' },
                    { start: 33, end: 33, label: '香港', color: '#dc9bbb' },
                    { start: 34, end: 34, label: '澳门', color: '#e0f7cc' }
                ]
            },
            }

            myChartChina.setOption(optionMap)
            window.onresize = function() {
            resizeMyChartContainer()
            myChartChina.resize()
            }
        },
    init() {
      let data = [
        { item: "男性", count: 100, percent: 0.33 },
        { item: "女性", count: 100, percent: 0.33 },
        { item: "未知", count: 100, percent: 0.33 },
        // { item: '事例四', count: 13, percent: 0.13 },
        // { item: '事例五', count: 9, percent: 0.09 },
      ];

      let chart = new this.$chart({
        container: "c1",
        autoFit: true,
        width: 300,
        height: 300,
      });

      chart.data(data);

      chart.coordinate("theta", {
        radius: 0.65,
      });

      chart.scale("percent", {
        formatter: (val) => {
          val = val * 100 + "%";
          // return val;
        },
      });
      chart.tooltip({
        showTitle: false,
        showMarkers: false,
      });
      chart.axis(false); // 关闭坐标轴
      const interval = chart
        .interval()
        .adjust("stack")
        .position("percent")
        .color("item", ["#76a4ff", "#ff8a89", "#d882f9"])
        .label("percent", {
          offset: -40,
          style: {
            textAlign: "center",
            shadowBlur: 2,
            shadowColor: "rgba(0, 0, 0, .45)",
            fill: "#fff",
          },
        })
        .tooltip("item*percent", (item, percent) => {
          percent = percent * 100 + "%";
          return {
            name: item,
            value: percent,
          };
        })
        .style({
          lineWidth: 1,
          stroke: "#fff",
        });
      chart.interaction("element-single-selected");
      chart.render();
    },
    init2() {
      const data = [
        { name: "下单金额", type: "0次", value: 0.2 },
        { name: "下单金额", type: "1次", value: 0.24 },
        { name: "下单金额", type: "2次", value: 0.66 },
        { name: "下单金额", type: "3次", value: 0.6 },
        { name: "下单金额", type: "4次以上", value: 0.24 },
      ];

      const chart = new this.$chart({
        container: "c3",
        autoFit: true,
        height: 280,
        // padding: [50, 20, 50, 20],
        padding: [20, 0, 60, 60],
      });
      registerTheme("newTheme", { minColumnWidth: 20, maxColumnWidth: 40 });
      chart.data(data);
      chart.scale("value", {
        alias: "下单金额(元)",
        nice: true,
      });
      chart.legend({
        marker: (name, index, item) => {
          return {
            style: {
              lineWidth: 1,
            },
          };
        },
      });
      chart.axis('type', {
      tickLine: null, // 不显示刻度线
      });
      chart.theme("newTheme");
      // chart.axis('value', false);
      // 处理Y轴的数据
      chart.axis("value", {
        label: {
          formatter: (val) => {
            return val * 100 + "%";
          },
        },
      });

      chart.tooltip({
        showMarkers: false,
      });
      chart
        .interval()
        .position("type*value")
        .tooltip("type*value", (type, value) => {
          value = value * 100 + "%";
          return {
            type,
            value,
          };
        });
      // chart.interval().position('type*value');
      chart.interaction("element-active");

      // 添加文本标注
      data.forEach((item) => {
        chart
          .annotation()
          .text({
            position: [item.type, item.value],
            content: (item.value * 100).toFixed(0) + "%",
            // content: item.value,
            style: {
              textAlign: "center",
            },
            offsetY: -12,
          })

          .text({
            position: [item.type, item.value],
            // content: (item.percent * 100).toFixed(0) + '%',
            style: {
              textAlign: "center",
            },
            offsetY: -12,
          });
      });
      chart.render();
    },
    init3() {
      const data = [
        { name: "下单金额", type: "0次", value: 0.2 },
        { name: "下单金额", type: "2-5次", value: 0.24 },
        { name: "下单金额", type: "5-10次", value: 0.66 },
        { name: "下单金额", type: "10-20次", value: 0.6 },
        { name: "下单金额", type: "20次以上", value: 0.24 },
      ];

      const chart = new this.$chart({
        container: "c4",
        autoFit: true,
        height: 280,
        // padding: [50, 20, 50, 20],
        padding: [20, 0, 60, 60],
      });
      registerTheme("newTheme", { minColumnWidth: 20, maxColumnWidth: 40 });
      chart.data(data);
      chart.scale("value", {
        alias: "下单金额(元)",
        nice: true,
      });
      chart.legend({
        marker: (name, index, item) => {
          return {
            style: {
              lineWidth: 1,
            },
          };
        },
      });
      // chart.axis('type', {
      // tickLine: null
      // });
      chart.theme("newTheme");
      // chart.axis('value', false);

    chart.axis('type', {
      tickLine: null, // 不显示刻度线
      });
      
      // 处理Y轴的数据
      chart.axis("value", {
        label: {
          formatter: (val) => {
            return val * 100 + "%";
          },
        },
      });
      chart.tooltip({
        showMarkers: false,
      });
      chart
        .interval()
        .position("type*value")
        .tooltip("type*value", (type, value) => {
          value = value * 100 + "%";
          return {
            type,
            value,
          };
        });
      // chart.interval().position('type*value');
      chart.interaction("element-active");

      // 添加文本标注
      data.forEach((item) => {
        chart
          .annotation()
          .text({
            position: [item.type, item.value],
            content: (item.value * 100).toFixed(0) + "%",
            // content: item.value,
            style: {
              textAlign: "center",
            },
            offsetY: -12,
          })

          .text({
            position: [item.type, item.value],
            // content: (item.percent * 100).toFixed(0) + '%',
            style: {
              textAlign: "center",
            },
            offsetY: -12,
          });
      });
      chart.render();
    },
    init4() {
      let data = [
        { item: "活跃人数", count: 100, percent: 0.43 },
        { item: "未活跃人数", count: 120, percent: 0.57 },
        // { item: '事例四', count: 13, percent: 0.13 },
        // { item: '事例五', count: 9, percent: 0.09 },
      ];

      let chart = new this.$chart({
        container: "c5",
        autoFit: true,
        width: 300,
        height: 300,
      });

      chart.data(data);

      chart.coordinate("theta", {
        radius: 0.65,
      });

      chart.scale("percent", {
        formatter: (val) => {
          val = val * 100 + "%";
          // return val;
        },
      });
      chart.tooltip({
        showTitle: false,
        showMarkers: false,
      });
      chart.axis(false); // 关闭坐标轴
      const interval = chart
        .interval()
        .adjust("stack")
        .position("percent")
        .color("item", ["#788dff", "#f9c038", "#d882f9"])
        .label("percent", {
          offset: -40,
          style: {
            textAlign: "center",
            shadowBlur: 2,
            shadowColor: "rgba(0, 0, 0, .45)",
            fill: "#fff",
          },
        })
        .tooltip("item*percent", (item, percent) => {
          percent = percent * 100 + "%";
          return {
            name: item,
            value: percent,
          };
        })
        .style({
          lineWidth: 1,
          stroke: "#fff",
        });
      chart.interaction("element-single-selected");
      chart.render();
    },
    init5() {
      let data = [
        { item: "青铜会员", count: 100, percent: 0.43 },
        { item: "黄金会员", count: 120, percent: 0.2 },
        { item: "白金会员", count: 120, percent: 0.1 },
        { item: "砖石会员", count: 120, percent: 0.13 },
        { item: "大师会员", count: 120, percent: 0.14 },
        // { item: '事例四', count: 13, percent: 0.13 },
        // { item: '事例五', count: 9, percent: 0.09 },
      ];

      let chart = new this.$chart({
        container: "c6",
        autoFit: true,
        width: 300,
        height: 300,
      });

      chart.data(data);

      chart.coordinate("theta", {
        radius: 0.65,
      });

      chart.scale("percent", {
        formatter: (val) => {
          val = val * 100 + "%";
          // return val;
        },
      });
      chart.tooltip({
        showTitle: false,
        showMarkers: false,
      });
      chart.axis(false); // 关闭坐标轴
      const interval = chart
        .interval()
        .adjust("stack")
        .position("percent")
        .color("item", ["#6ab1ff", "#45d2d1", "#56cb73", "#f7c739", "#eb7e65"])
        .label("percent", {
          offset: -40,
          style: {
            textAlign: "center",
            shadowBlur: 2,
            shadowColor: "rgba(0, 0, 0, .45)",
            fill: "#fff",
          },
        })
        .tooltip("item*percent", (item, percent) => {
          percent = percent * 100 + "%";
          return {
            name: item,
            value: percent,
          };
        })
        .style({
          lineWidth: 1,
          stroke: "#fff",
        });
      chart.interaction("element-single-selected");
      chart.render();
    },
    init6() {
      const data = [
        { name: "使用次数", 月份: "优惠券1.", 月均降雨量: 189 },
        { name: "使用次数", 月份: "优惠券2", 月均降雨量: 288 },
        { name: "使用次数", 月份: "优惠券3", 月均降雨量: 393 },
        { name: "使用次数", 月份: "优惠券4", 月均降雨量: 314 },
        { name: "使用次数", 月份: "优惠券5", 月均降雨量: 47 },
        { name: "使用次数", 月份: "优惠券6", 月均降雨量: 203 },
        { name: "使用次数", 月份: "优惠券7", 月均降雨量: 24 },

        { name: "领取次数", 月份: "优惠券1.", 月均降雨量: 124 },
        { name: "领取次数", 月份: "优惠券2", 月均降雨量: 232 },
        { name: "领取次数", 月份: "优惠券3", 月均降雨量: 345 },
        { name: "领取次数", 月份: "优惠券4", 月均降雨量: 397 },
        { name: "领取次数", 月份: "优惠券5", 月均降雨量: 526 },
        { name: "领取次数", 月份: "优惠券6", 月均降雨量: 355 },
        { name: "领取次数", 月份: "优惠券7", 月均降雨量: 374 },
      ];

      const chart = new Chart({
        container: "c7",
        autoFit: true,
        height: 300,
      });

      chart.data(data);
      chart.scale("月均降雨量", {
        nice: true,
      });
      chart.tooltip({
        shared: true,
        showMarkers: false,
      });

      chart
        .interval()
        .position("月份*月均降雨量")
        .color("name")
        .adjust("stack");

      chart.interaction("active-region");

      chart.render();
    },
  },
};
</script>

<style lang="less">


</style>
<style lang="less" scoped>
#blue{
    background-image: linear-gradient(to right, #00C4FF , #0091FF);
}
.portrayal {
  padding: 29px;
      .lis{
        padding:30px;
        .l{
            margin-bottom:30px;
            padding:15px 30px;
            border-radius: 6px;
            background: #F1F1F1;
            display: flex;
            align-items: center;
            img{
                margin-right:15px;
                width:34px;
                height:34px;
            } 
            font-size: 14px;
            font-weight: 400;
            color: #333333;
        }
        .li{
            // margin-bottom:30px;
            .c{
                display: flex;
                div{
                    padding-bottom:60px;
                }
                .icons{
                    display: block;
                    flex-shrink:0;
                    position: relative;
                    margin-right:30px;
                    span{
                        display: block;
                        
                        // margin-right:30px;
                        width: 24px;
                        height: 24px;
                        text-align: center;
                        line-height: 24px;
                        background: #DEEAFF;
                        border-radius: 2px;
                        font-size: 14px;
                        font-weight: 500;
                        color: #327EFF;
                    }
                    &::after{
                        content: '';
                        position: absolute;
                        top: 24px;
                        left: 10px;
                        background: #A3A3A3;
                        width: 1px;
                        height: 100%;
                    }
                    
                }
                &:last-child{
                    .icons{
                        &::after{
                            display: none !important;
                        }
                    }
                    
                }
                .title{
                    font-size: 14px;
                    font-weight: 500;
                    color: #333333;
                }
                .dj {
                    padding-top:15px;
                    span{
                        margin-right:15px;
                        padding: 6px 12px;
                        background: rgba(250, 100, 0, 0.09);
                        border-radius: 16px;
                        font-size: 14px;
                        font-weight: 400;
                        color: #FF8E42;
                    }
                    
                }
                .xb{
                    padding-top:15px;
                    span{
                        padding: 6px 18px;
                        background: rgba(211, 236, 255, 0.47);
                        text-align: center;
                        border-radius: 16px;
                        font-size: 14px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #0091FF;
                    }
                }
                .qd{
                    padding-top:15px;
                    .ft{
                        padding-bottom:15px;
                        display: block;
                        font-size: 14px;
                        font-weight: 400;
                        color: #333333;
                    }
                    .text{
                        padding-bottom:15px;
                        display: block;
                        font-size: 12px;
                        font-weight: 400;
                        color: #777777;
                    }
                    .f{
                        display: block;
                        span{
                            margin-right:8px;
                            margin-bottom:10px;
                            display: inline-block;
                            padding:6px 12px;
                            font-size: 14px;
                            font-weight: 400;
                            color: #FFFFFF;
                            background: #327EFF;
                            border-radius: 16px;
                        }                           
                    }
                }
            }
        }
    }
  // 顶部区域
    .portrayal_f1{
        .portrayal_title{
            img{
                margin-right:10px;
                width:20px;
                height:20px;
                vertical-align: middle;
            }
            font-size: 16px;
            font-weight: 500;
            color: #333333;
        }
        .portrayal_content{
            width:100%;
            box-sizing: border-box;
            padding:30px;
            background: #fff;
            .portrayal_d1{
                display: flex;
                align-items: center;
                padding-bottom:30px;
                border-bottom:1px dashed #ccc;
                img{
                    margin-right:10px;
                    width:46px;
                    height:46px;
                }
                p{
                    font-size: 14px;
                    font-weight: 500;
                    color: #333333;
                    &:last-child{
                        margin-top:4px;
                        font-size: 12px;
                        font-weight: 400;
                        color: #999999;
                    }
                }
            }
            .portrayal_d2{
                display: flex;
                padding-top:15px;
                .portrayal_group{
                    display: inline-block;
                    width:48%;
                    padding-right:60px;
                    box-sizing: border-box;
                }
                .portrayal_label{
                  display: inline-block;
                    .portrayal_t{
                        padding-left:60px;
                    }
                    box-sizing: border-box;
                    width:48%;
                    .portrayal_lab{
                        padding-left:60px;
                        border-left:1px solid #EEEEEE;
                    }
                   
                    /deep/ .el-tag{
                        margin-right:10px;
                        margin-bottom:10px;
                        border-radius: 30px;
                        margin-bottom:10px;
                    }
                }
                
                .portrayal_t{
                    margin-bottom:15px;
                    img{
                        margin-right:10px;
                        width:16px;
                        height: 16px;
                        vertical-align: middle;
                    }
                }
                .portrayal_lis{
                    .portrayal_l{
                        margin-bottom:15px;
                        padding:15px 30px;
                        border-radius: 6px;
                        background: #F1F1F1;
                        display: flex;
                        align-items: center;
                        img{
                            margin-right:15px;
                            width:34px;
                            height:34px;
                        } 
                        font-size: 14px;
                        font-weight: 400;
                        color: #333333;
                    }
                    .portrayal_li{
                        // margin-bottom:30px;
                        .c{
                            display: flex;
                            div{
                                padding-bottom:60px;
                            }
                            .icons{
                                display: block;
                                flex-shrink:0;
                                position: relative;
                                margin-right:30px;
                                span{
                                    display: block;
                                    
                                    // margin-right:30px;
                                    width: 24px;
                                    height: 24px;
                                    text-align: center;
                                    line-height: 24px;
                                    background: #DEEAFF;
                                    border-radius: 2px;
                                    font-size: 14px;
                                    font-weight: 500;
                                    color: #327EFF;
                                }
                                &::after{
                                    content: '';
                                    position: absolute;
                                    top: 24px;
                                    left: 10px;
                                    background: #A3A3A3;
                                    width: 1px;
                                    height: 100%;
                                }
                                
                            }
                            &:last-child{
                                .icons{
                                    &::after{
                                        display: none !important;
                                    }
                                }
                                
                            }
                            .title{
                                font-size: 14px;
                                font-weight: 500;
                                color: #333333;
                            }
                            .dj {
                                padding-top:15px;
                                span{
                                    margin-right:15px;
                                    padding: 6px 12px;
                                    background: rgba(250, 100, 0, 0.09);
                                    border-radius: 16px;
                                    font-size: 14px;
                                    font-weight: 400;
                                    color: #FF8E42;
                                }
                                
                            }
                            .xb{
                                padding-top:15px;
                                span{
                                    padding: 6px 18px;
                                    background: rgba(211, 236, 255, 0.47);
                                    text-align: center;
                                    border-radius: 16px;
                                    font-size: 14px;
                                    font-family: PingFangSC-Regular, PingFang SC;
                                    font-weight: 400;
                                    color: #0091FF;
                                }
                            }
                            .qd{
                                padding-top:15px;
                                .ft{
                                    padding-bottom:15px;
                                    display: block;
                                    font-size: 14px;
                                    font-weight: 400;
                                    color: #333333;
                                }
                                .text{
                                    padding-bottom:15px;
                                    display: block;
                                    font-size: 12px;
                                    font-weight: 400;
                                    color: #777777;
                                }
                                .f{
                                    display: block;
                                    span{
                                        margin-right:8px;
                                        margin-bottom:10px;
                                        display: inline-block;
                                        padding:6px 12px;
                                        font-size: 14px;
                                        font-weight: 400;
                                        color: #FFFFFF;
                                        background: #327EFF;
                                        border-radius: 16px;
                                    }                           
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    /deep/ .el-tabs__nav-wrap::after{
        display: none;
    }
    .tabs{
        padding:15px 30px;
        
    }
  //图表区域
  .my-chart {
    // margin-top: 30px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .my-chart-com {
      width: 49%;
      height: 400px;
      margin-bottom: 30px;
      position: relative;
      .txtcolor {
        color: #4881fe;
      }
      .top {
        // margin-top: 20px;
        .fl {
          float: left;
          font-size: 16px;
          display: flex;
          b {
            margin-left: 6px;
          }
          img {
            width: 24px;
          }
          .text {
            margin-left: 12px;
            color: #999999;
            font-size: 12px;
            line-height: 24px;
          }
        }
        .fr {
          float: right;
          color: #999999;
          font-size: 12px;
        }
      }
      .mian {
        display: flex;
        position: absolute;
        top: 50%;
        margin-top: -68px;
        margin-left: 62px;
        .m1 {
          border-radius: 50%;
         
        }
        .m2 {
          margin-left: 20px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          color: #0091ff;
        }
        .m3 {
          margin-left: 20px;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
      }
      #c7 {
        margin-top: 20px;
      }
      .ybp .m1{
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          /deep/ .el-progress__text{
              display: none;
            // font-size: 46px !important;
            // font-family: DINAlternate-Bold, DINAlternate;
            // font-weight: bold;
            // color: #0091FF;
          }

          .fonts{
                position: absolute;
                width:100%;
                top: 114px;
                text-align: center;
                // left: 110px;
                font-size: 46px;
                font-family: DINAlternate-Bold, DINAlternate;
                font-weight: 600;
                color: #0091FF;
                span{
                    font-weight: 400;
                    font-size:31px;
                }
          }
      }
      .mian2 {
        display: flex;
        align-items: center;
        // 解决方法字体掉落问题
        margin-right: -40px;
        .m1 {
          width: 300px;
          height: 300px;
         
        }
        #c5 {
          width: 400px;
          height: 300px;
        }
        #c6 {
          width: 500px;
          height: 300px;
        }

        .m2 {
          h1 {
            color: #4881fe;
            margin-bottom:10px;
            span {
              
              font-size: 16px;
            }
          }
          span{
              display: inline-block;
              // width:100px;
              text-align: right;
              font-size: 14px;
          }
          
        }
      }
      .main4 {
        .m1 {
          margin-top: 30px;
          margin-left: 30px;
          margin-bottom: 20px;
          font-size: 14px;
            font-weight: 400;
            color: #333333;
        }
      }
      .mian5{
          position: relative;
          .m2{
              position: absolute;
              right: 70px;
                top: 68px;
              p{
                font-size: 14px;
                font-weight: 400;
                color: #333333;
                b{
                    font-size:24px;
                }
              }
          }
      }
      .photo9 {
        .el-table__row {
          height: 50px;
        }
      }
      .box3 {
        margin-top: 20px;
        div{
            display: inline-block;
            width:33.1%;
            text-align: center;
            border-right: 1px solid #EBEBEB;
            &:last-child{
                border:0;
            }
        }
        // display: flex;
        // justify-content: space-around;
        // align-items: center;
        background: #fff;
        padding:15px 0;
      }
    }
    .my-chart-com{
        height:auto !important;
    }
    .my-table {
        padding:0;
        /deep/ .el-card__body{
            padding:0;
            background: #F5F7FB !important;
        }
        /deep/ .el-card{
            background-color: inherit !important;
        }
        .fl{
            padding:20px;
        }
        .tabl{
            background: #fff;
        }
       
    //   height: 450px;
    }
    .el-card__body{

    }
  }
  .el-table {
    border: 0 solid #000;
    .el-tooltip{
     padding-right: 104px;
    }
  }
}
</style>